<template>
  <v-app style="background-color: white;">
    <div v-if="packages!=null" style="padding-top: 150px;background-size: cover;height: 100%;padding-bottom: 200px;" :style="{backgroundImage: `linear-gradient(to bottom, rgba(128, 128, 128, 0.73), rgba(0, 0, 0, 0.73)), url(${detail.src})`}">
      <h1 class="bannerTitle">{{ detail.name }} ({{ detail.day }} Days)</h1>
      <v-conatiner>
        <div class="row" style="padding-top: 80px;">
        <div class="col-lg-9 col-md-9 col-sm-12" style="color: #FFFFFF;">
           <h2 style="margin-left: 10px;" class="txt_my">Tour Covering</h2>
           <p style="margin-left: 10px;font-size: 18px;" class="txt_my">{{packages.description}}</p>
           <v-divider :thickness="8" color="white" style="color: white"></v-divider><br/>
           <h2 v-if="packages.nightStay!=null" style="margin-left: 10px;" class="txt_my">Night Stay</h2>
           <p v-if="packages.nightStay!=null" style="margin-left: 10px;font-size: 18px;" class="txt_my">{{packages.nightStay}}</p>
           <v-divider v-if="packages.nightStay!=null" :thickness="8" color="white" style="color: white"></v-divider><br/>
           <h2 style="margin-left: 10px;" class="txt_my">Date of Journey</h2>
           <p style="margin-left: 10px;font-size: 18px;" class="txt_my">{{packages.journeyDate}}</p>
           <v-divider :thickness="8" color="white" style="color: white"></v-divider><br/>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12" style="text-align: center;margin-top: -150px;">
          <div v-if="packages.actualRate!=null" style="display: flex;align-items: center;justify-content: center;">
            <v-card style="height: 150px;width: 150px;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin-top: 5px;">
              <!-- <h6 class="txt_my" style="font-weight: bold;">2 person in a DBR<br/> -->
                <span class="txt_my" style="font-size: 18px;color: grey;font-weight: bold;"> {{ packages.actualRate }}/-</span>
              <!-- </h6> -->
            </v-card>
          </div>
          <div v-if="packages.regularRate!=null" style="display: flex;align-items: center;justify-content: center;">
            <v-card style="height: 150px;width: 150px;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin-top: 5px;">
              <!-- <h6 class="txt_my" style="font-weight: bold;">3 person in a DBR<br/> -->
                <span class="txt_my" style="font-size: 18px;color: grey;font-weight: bold;"> {{ packages.regularRate }}/-</span>
              <!-- </h6> -->
            </v-card>
          </div>
          <div v-if="packages.rate=='Yes'" style="display: flex;align-items: center;justify-content: center;">
            <v-card style="height: 150px;width: 150px;border-radius: 50%;display: flex;align-items: center;justify-content: center;margin-top: 5px;">
              <h6 class="txt_my" style="font-weight: bold;">Air Ticket Extra</h6>
            </v-card>
          </div>
          <v-btn @click.stop="enquiryDialog = true" style="border-radius: 20px !important;color: #FFFFFF;margin-top: 35px;" large flat outline> Book Now </v-btn>    
        </div>
        </div>

        <div class="row">
          <div class="col-12">
            <v-tabs align-tabs="center" color="transparent" centered vertical style="padding-top:10px;">
              <v-tab class="white--text" style="text-align: center;">
                Itinerary
              </v-tab>
              <v-tab class="white--text" style="text-align: center;">
                Inclusion / Exclusion
              </v-tab>
              <v-tab class="white--text" style="text-align: center;">
                Booking Policy
              </v-tab>


              <v-tab-item color="transparent">
                <v-card flat color="transparent" style="margin: 20px;border: 2px solid !important;border-color: #FFFFFF;">
                  <div v-for="item in packages.itinerary" :key="item.id">
                    <h4 class="txt_my" style="color: #FFFFFF;font-weight: 200;">{{ item.title }}</h4>
                    <div v-for="itid in item.itineraryDetails" :key="itid.id">
                      <p class="txt_my" style="color: #FFFFFF;font-weight: 100 !important;">{{ itid.description }}</p>
                    </div>
                  <v-divider color="white"></v-divider>
                  </div>
                </v-card>
              </v-tab-item>

              <v-tab-item color="transparent">
                <v-card flat color="transparent" style="margin: 20px;border: 2px solid !important;border-color: #FFFFFF;">
                  <h4 class="txt_my" style="color: #FFFFFF;font-weight: 200;">Inclusion</h4>
                  <div v-for="inclu in packages.inclusion" :key="inclu.id">
                    <p class="txt_my" style="color: #FFFFFF;font-weight: 100 !important;">{{ inclu.description }}</p>
                  </div>
                  <v-divider color="white"></v-divider>
                  <h4 class="txt_my" style="color: #FFFFFF;font-weight: 200;">Exclusion</h4>
                  <div v-for="exclu in packages.exclusion" :key="exclu.id">
                    <p class="txt_my" style="color: #FFFFFF;font-weight: 100 !important;">{{ exclu.description }}</p>
                  </div>
                  <v-divider color="white"></v-divider>
                  <h4 class="txt_my" style="color: #FFFFFF;font-weight: 200;">Optionals (arranged on request at additional cost)</h4>
                  <div v-for="exclu in packages.optional" :key="exclu.id">
                    <p class="txt_my" style="color: #FFFFFF;font-weight: 100 !important;">{{ exclu.name }}</p>
                  </div>
                </v-card>
                
              </v-tab-item>

              <v-tab-item color="transparent">
                <v-card flat color="transparent" style="margin: 20px;border: 2px solid !important;border-color: #FFFFFF;">
                  <v-layout wrap v-for="(inclu, index) in packages.policy" :key="inclu.id">
                    <v-flex xs1 sm1 md1 style="color: #FFFFFF;">{{index+1}} .</v-flex>
                    <v-flex xs11 md11 sm11>
                      <p class="txt_my" style="color: #FFFFFF;font-weight: 100 !important;">{{ inclu.description }}</p>
                      <v-divider color="white"></v-divider>
                    </v-flex>
                  </v-layout>
                </v-card>
                
              </v-tab-item>
            </v-tabs>
          </div>
        </div>
      </v-conatiner>
    </div>


    <v-dialog v-model="enquiryDialog" max-width="600">
             <v-card style="border-radius:0px;margin-top:80px">   <!-- style="margin-top:80px" -->
                <h4 style="text-align:center;padding-top:15px">Request Quote</h4>
                <v-divider></v-divider>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout row wrap style="padding:15px">
                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-text-field
                          v-model="form.email"
                          append-icon="mark_email_read"
                          label="Email ID"
                          type="text"
                          :rules="[rules.emailid]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-text-field
                          v-model="form.mobileNumber"
                          append-icon="call"
                          label="Mobile number"
                          type="number"
                          min="0"
                          :rules="[rules.mobileno]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12>
                      <v-text-field
                          v-model="form.destination"
                          label="Destination(s)"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-text-field
                          v-model="form.startingFrom"
                          label="Starting From"
                          type="text"
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                      <v-dialog ref="dialog" v-model="dateModel" persistent lazy full-width width="310px">
                           <v-text-field
                             append-icon="event"
                             slot="activator"
                             v-model="form.startDate"
                             label="Start Date"
                             readonly
                           ></v-text-field>
                              <v-date-picker v-model="form.startDate" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn flat color="primary" @click="dateModel = false">Ok</v-btn>
                              </v-date-picker>
                    </v-dialog>
                    </v-flex>

                    <v-flex xs12 sm12 md6 style="padding-right:5px">
                      <v-autocomplete
              v-model="selectedDuration"
              :items="durations"
              color="primary"
              label="Trip Duration"
              item-text="durations"
              item-value="durations"
              clearable
            ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md6> 
                      <v-text-field
                          v-model="form.budget"
                          label="Approximate Budget"
                          type="Number"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md2 style="padding-right:5px"> 
                      <v-text-field
                          v-model="form.adult"
                          label="(Adults: 12+ Yrs)"
                          type="Number"
                          :rules="[rules.required]"
                          required
                          ></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md2 style="padding-right:5px"> 
                      <v-text-field
                          v-model="form.children"
                          label="(Child: 2-12 Yrs)"
                          type="Number"
                          ></v-text-field>
                    </v-flex>


                    <v-flex xs12 sm12 md4 style="padding-right:5px">
                      <v-autocomplete
              v-model="selectedTransportation"
              :items="transportations"
              color="primary"
              label="Transportation"
              item-text="transportations"
              item-value="transportations"
              clearable
            ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12 sm12 md4> 
                      <v-autocomplete
              v-model="selectedAccommodation"
              :items="accommodations"
              color="primary"
              label="Accommodation"
              item-text="accommodations"
              item-value="accommodations"
              clearable
            ></v-autocomplete>
                    </v-flex>

                    <v-flex xs12>
                      <v-textarea
                         :rows="3"
                          v-model="form.notes"
                          label="Notes / Special Requirements"
                          ></v-textarea>
                    </v-flex>

                    <v-flex xs12>
                      <b-form-checkbox v-model="form.need">Need transportation from my Starting City</b-form-checkbox>
                    </v-flex>

                    <v-flex xs12 style="text-align:right">
                         <v-btn color="grey" dark @click.stop="enquiryDialog = false">Cancel</v-btn>
                         <v-btn :loading="btnSave" color="primary" dark @click="onSubmit()">Enquiry Now</v-btn>
                     </v-flex>
                  </v-layout>
                </v-form> 
             </v-card>
           </v-dialog>
  </v-app>
</template>

<script>
import config from "./../../config.json";
export default {
  data() {
    return {
      valid: true,
      btnSave: false,
      packages: null,
      dateModel: false,
      enquiryDialog: false,
      detail: null,

      rules: {
        required: value => !!value || "Required.",
        mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
        emailid: value => {
          const pattern = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
          return pattern.test(value) || "Email Id is not valid!!";
        },
      },

      form: {
        email: null,
        mobileNumber: null,
        destination: null,
        startingFrom: null,
        startDate: null,
        budget: null,
        adult: 1,
        children: 0,
        notes: null,
        need: false
      },

      durations: ["2 Days & 1 Night", "3 Days & 2 Nights", "4 Days & 3 Nights", "5 Days & 4 Nights", "6 Days & 5 Nights", "7 Days & 6 Nights", "8 Days & 7 Nights", "9 Days & 8 Nights", "10 Days & 9 Nights", "More Than 10 Days"],
      selectedDuration: null,

      transportations: ["Standard Vehicle", "Hatchback (4 Pax)", "Sedan (4 Pax)", "SUV (7 Pax)", "Luxury Car (4/7 Pax)", "Tempo (12-15 Pax)", "Small Coach (20 Pax)", "Coach (25-30 Pax)", "Mini Bus (35-40 Pax)", "Bus (50 Pax)", "Other (Provide Notes)"],
      selectedTransportation: null,

      accommodations: ["Budget Accommodation", "2-star Accommodation", "3-Star Accommodation", "4-Star Accommodation", "3-Star & Above"],
      selectedAccommodation: null

    };
  },

  methods: {
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .post(
            config.API + `Enquiries`,
            {
              email: this.form.email,
              mobileNumber: this.form.mobileNumber,
              destination: this.form.destination,
              startingFrom: this.form.startingFrom,
              startDate: this.form.startDate,
              duration: this.selectedDuration,
              budget: this.form.budget,
              adult: this.form.adult,
              children: this.form.children,
              transportation: this.selectedTransportation,
              accommodation: this.selectedAccommodation,
              notes: this.form.notes,
              need: this.form.need
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Your Enquiry has been Successfully send");
            this.enquiryDialog = false;
            this.btnSave = false;
            this.$refs.form.reset();
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    }
  },

  mounted() {
    let _detail = sessionStorage.getItem("Detail")
    this.detail=JSON.parse(_detail);
    console.log(this.detail.name);
    this.axios
        .get(config.API + `TourPackages1/${this.$route.params.id}`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          console.log(res);
          this.packages = res.data;
          this.$Progress.finish();
        })
    this.$Progress.start();
  }
};
</script>
<style lang="css" scoped>
.banner {
  /* background-image: url('../../assets/places-divider.jpg');
  background-size: cover; */
  /* height:250px; */
  margin-top: -800px;
}
.bannerTitle {
  margin: 0;
  text-align: center;
  color: white;
  font-size: 50px;
  font-family: "Alice", serif !important;
}
.txt_my {
  font-family: "Alice", serif !important;
}
.htg {
  top: -130px;
  position: relative;
}
.lineThrough {
  text-decoration: line-through;
}
.top-left {
  position: absolute;
  top: 8px;
  left: 16px;
}
.tourtheme {
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.bckclr {
  -webkit-text-fill-color:cornflowerblue
}
.bckdiv {
    background-image: url("../../assets/contact.jpg");
    height: 400px;
    background-size: cover;
}
.price-box {
  display: flex ;
}

.price-box .price {
  margin-left: 5px;
}
.price-box p {
margin-bottom: 3px;}
/* .price-box p {
  font-weight: 500;
} */
.txt_dec:hover {
    text-decoration: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}

.container {
    position: relative;
    width: 200px;
    height: 400px;
}

.curve {
    position: absolute;
    width: 100%;
    height: 50%;
    background-color: #3498db;
    border-radius: 50%;
}

.top {
    top: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.bottom {
    bottom: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>